import styled from 'styled-components'

export const StyledDepositListContainer = styled.div`
  background: #ffffff;
  padding: 20px 36px;
  border-radius: 12px;
  margin-top: 25px;
  .record-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 19px;
    border-bottom: 0.5px solid rgba(67, 69, 79, 0.1);
    .title {
      color: ${({ theme }) => theme.colors.textContent};
      font-weight: bold;
      font-size: 17px;
    }
    .sub-title {
      margin-bottom: 0;
      .tips {
        color: ${({ theme }) => theme.colors.textTertiary};
        font-size: 15px;
        // margin-left: 10px;
        margin-right: 5px;
      }
      .lon-total-balance {
        font-size: 15px;
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
  .infinite-container {
    &::-webkit-scrollbar {
      width: 0px;
    }
    &:-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: rgba(255, 255, 255, 0.5); //设置背景透明
    }
  }
  @media screen and (max-width: 640px) {
    padding: 15px;
    margin-bottom: 80px;
    .infinite-container {
      overflow-x: scroll !important;
      .deposit-list-wrapper {
        width: 600px;
      }
    }
    .record-head {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .lon-total-balance,
      .sub-title {
        margin-left: 0;
        font-size: 13px;
      }
    }
    .ant-table-cell {
      white-space: nowrap;
    }
  }
`

export const StyledDepositListWrapper = styled.div`
  padding-top: 25px;
  .ant-row {
    color: ${({ theme }) => theme.colors.textTertiary};
    font-size: 13px;
  }
  .head-row,
  .content-row {
    .last-col {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .content-row {
    padding: 24px 0px 16px 0;
    border-bottom: 0.5px solid rgba(67, 69, 79, 0.2);
  }
  .deposit {
    color: #ffcc5f;
  }
  .redeem {
    color: #4dd8d0;
  }
  .unlock {
    color: ${({ theme }) => theme.colors.primary};
  }
  .action-type {
    font-size: 17px;
  }
  .receive-amount {
    font-size: 17px;
    color: ${({ theme }) => theme.colors.textContent};
  }
  .penalty-amount {
    font-size: 17px;
    color: ${({ theme }) => theme.colors.textTertiary};
  }
  .sort-element {
    white-space: nowrap;
  }
`
